import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import Dropdown from "../../modules/Dropdown";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import ListItem from "./components/ListItem";
import { Provider as CurrentListItemProvider } from "./currentListItemContext";
import rehydrator from "./FilteredList.rehydrator";

var FilteredList = /*#__PURE__*/function (_React$Component) {
  _inherits(FilteredList, _React$Component);

  var _super = _createSuper(FilteredList);

  function FilteredList() {
    var _this;

    _classCallCheck(this, FilteredList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedListingsKey: null,
      listKeys: []
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(FilteredList.displayName));

    _defineProperty(_assertThisInitialized(_this), "onListingsKeyChanged", function (value) {
      _this.setState({
        selectedListingsKey: value
      });
    });

    return _this;
  }

  _createClass(FilteredList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState(function (state, props) {
        var listKeys = _this2.getListingsKeys(props.children);

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedListingsKey: null,
          listKeys: listKeys
        });
      });
    }
  }, {
    key: "getListingsKeys",
    value: function getListingsKeys(children) {
      var _this3 = this;

      var listKeys = [];
      React.Children.forEach(children, function (child) {
        if (child.type === ListItem) {
          if (listKeys.includes(child.props.category)) {
            return;
          }

          listKeys.push(child.props.category);
        } else if (child.type === React.Fragment) {
          listKeys.push.apply(listKeys, _toConsumableArray(_this3.getListingsKeys(child.props.children)));
        }
      });
      return listKeys;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          placeholder = _this$props.placeholder;
      var rootClassName = this.getClassName();
      var titleClassName = this.getClassName({
        descendantName: "title"
      });
      var listingContainerClassName = this.getClassName({
        descendantName: "listing-container"
      });
      var rootRehydratableName = getRehydratableName(FilteredList.displayName);
      var mappedListingsKeys = this.state.listKeys.map(function (key) {
        return {
          value: key,
          label: key
        };
      });
      return /*#__PURE__*/React.createElement("div", {
        className: rootClassName,
        "data-rehydratable": rootRehydratableName,
        "data-label": label,
        "data-placeholder": placeholder
      }, /*#__PURE__*/React.createElement("span", {
        className: titleClassName
      }, label), /*#__PURE__*/React.createElement(Dropdown, {
        items: mappedListingsKeys,
        placeholder: placeholder,
        onValueChanged: this.onListingsKeyChanged,
        size: "small",
        value: this.state.selectedListingsKey
      }), /*#__PURE__*/React.createElement("div", {
        className: listingContainerClassName,
        "data-rehydratable-children": true
      }, /*#__PURE__*/React.createElement(CurrentListItemProvider, {
        value: this.state.selectedListingsKey
      }, children)));
    }
  }]);

  return FilteredList;
}(React.Component);

_defineProperty(FilteredList, "displayName", "FilteredList");

_defineProperty(FilteredList, "ListItem", void 0);

_defineProperty(FilteredList, "rehydrator", rehydrator);

_defineProperty(FilteredList, "defaultProps", {
  label: "Contact a Representative",
  placeholder: "Select a Country"
});

FilteredList.ListItem = ListItem;
export default FilteredList;